<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-12 md:py-12 py-5 bge3ceff-opa">
    <p
      class="fsize40 md-fsize28 sm-fsize20 font-semibold text-center clr-black lg:mb-12 md:mb-8 mb-6"
    >
      Recommended Videos
      <!-- {{
        Object.keys(user).length <= 0 || !getAllHistory.result.length
          ? "Recommended Videos"
          : "Your Recent Episodes"
      }} -->
    </p>
    <div>
      <swiper :options="swiperOption" class="mySwiper">
        <template
          v-if="Object.keys(user).length <= 0 || !getAllHistory.result.length"
        >
          <swiper-slide
            class="cursor-pointer"
            v-for="(item, index) in allEpisode"
            :key="index"
          >
            <div @click="createHistory(item._id)">
              <div
                class="relative w-full h-200 rounded-xl"
                @click="handleOpen(item.video_url)"
              >
                <img
                  class="w-full h-200 rounded-xl"
                  :src="handleFrame(item.video_url)"
                  alt="img"
                />
                <feather-icon
                  icon="PlayIcon"
                  class="clr-black icon-abs"
                  svgClasses="w-6 h-6"
                ></feather-icon>

                <!-- <iframe
                class="w-full h-full rounded-xl border-0"
                :src="handleFrame(item.episodeId.video_url)"
                frameborder="0"
              ></iframe> -->
                <div
                  class="absolute inset-0 w-full h-full bg-red cursor-pointer"
                ></div>
              </div>
              <p
                class="clr-black mt-4 sm-fsize14"
                @click="handleOpen(item.video_url)"
              >
                {{ item.title }}
              </p>
            </div>
          </swiper-slide>
        </template>
        <template v-else>
          <swiper-slide
            class="cursor-pointer"
            v-for="(item, index) in getAllHistory.result"
            :key="index"
          >
            <div @click="updateHistory(item._id)">
              <div
                class="relative w-full h-200 rounded-xl"
                @click="handleOpen(item.episodeId.video_url)"
              >
                <img
                  class="w-full h-200 rounded-xl"
                  :src="handleFrame(item.episodeId.video_url)"
                  alt="img"
                />
                <feather-icon
                  icon="PlayIcon"
                  class="clr-black icon-abs"
                  svgClasses="w-6 h-6"
                ></feather-icon>

                <!-- <iframe
                class="w-full h-full rounded-xl border-0"
                :src="handleFrame(item.episodeId.video_url)"
                frameborder="0"
              ></iframe> -->
                <div
                  class="absolute inset-0 w-full h-full bg-red cursor-pointer"
                ></div>
              </div>
              <p
                class="clr-black mt-4 sm-fsize14"
                @click="handleOpen(item.episodeId.video_url)"
              >
                {{ item.episodeId.title }}
              </p>
            </div>
          </swiper-slide>
        </template>
      </swiper>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        breakpoints: {
          1600: {
            slidesPerView: 4.3,
            spaceBetween: 30,
          },
          1300: {
            slidesPerView: 4.3,
            spaceBetween: 30,
          },
          900: {
            slidesPerView: 3.2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1.3,
            spaceBetween: 15,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true,
        observeParents: true,
      },

      openAddBannerSidebar: false,
      allEpisode: {},
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    async dataLoad() {
      let payload = {
        limit: 7,
        sort: "-1",
        isRecommended: true,
      };
      if (Object.keys(this.user).length > 0) {
        console.log("If", this.user);
        let { data } = await this.$store.dispatch("playlist/getall_history");
        this.allEpisode = data.result;
      }
      let { data } = await this.$store.dispatch(
        "playlist/getall_episode",
        payload
      );
      console.log("allEpisode", data.result);
      this.allEpisode = data.result;
    },

    async createHistory(id) {
      if (Object.keys(this.user).length <= 0) return;
      let payload = {
        episodeId: id,
      };
      try {
        await this.$store.dispatch("playlist/add_history", payload);
        this.dataLoad();
      } catch (error) {
        console.log(error);
      }
    },
    async updateHistory(id) {
      if (Object.keys(this.user).length <= 0) return;
      let payload = {
        id: id,
      };
      try {
        await this.$store.dispatch("playlist/update_history", payload);
        await this.$store.dispatch("playlist/getall_history");
      } catch (error) {
        console.log(error);
      }
    },
    handleFrame(url) {
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    },
    handleOpen(url) {
      window.open(url, "_blank");
    },
  },
  computed: {
    ...mapState("playlist", {
      getAllHistory: "getAllHistory",
      getAllEpisode: "getAllEpisode",
    }),
    ...mapState("auth", { user: "user" }),
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
